import { svgIcon } from "@utils/function";
/**
 * @param {object} id, posOrGroup, fullname, country, parOrTee, thruOrTime
 */

export default function RowTemplate({
  idglobal,
  posOrGroup,
  fullname,
  country,
  proam,
  parOrTee,
  thruOrTime,
  courseColor,
  thruColumn,
}) {
  const colorsMultiCourse = courseColor
    ? `style="--course-color:${courseColor}"`
    : "";

  const className =
    HQ.Properties.typeSite === "scoring" ? "player-favorites" : "";

  const countryFlag = country
    ? `<span title="${country}" class="flag-icon flag-icon-${country.toLowerCase()}"></span>`
    : "";

  return `
    <tr ${colorsMultiCourse} data-id="${idglobal}" class="active-row" id="favorite-${idglobal}">
      <td class="text-center">${posOrGroup}</td>
      <td class="${className}">${fullname} ${proam}</td>
      <td class="text-center">${countryFlag}</td>
      <td class="text-center">${parOrTee}</td>
      ${thruOrTime || ""}
      ${thruColumn || ""}
      <td>
        <div class="icon-star text-center" title="Add player ${fullname} to Favorites">
        ${svgIcon({ name: "icon-star" })}
        </div>
      </td>
    </tr>`;
}
